class HoverDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    // 禁用默认的点击切换行为
    this.summary.addEventListener('click', (e) => e.preventDefault());

    // 鼠标悬停时展开
    this.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('mouseleave', this.close.bind(this));

    // 初始化动画（保留原有逻辑）
    this.animations = this.content.getAnimations();
  }

  setDisclosurePosition(){
    if(!this.header) this.header = document.querySelector('header.header');
    if(!this.header) return;

    const bcr = this.header.getBoundingClientRect();

    this.content.style.top = `${bcr.height + bcr.top - 16}px`;
  }

  open() {
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');

    this.setDisclosurePosition();

    this.animations.forEach(animation => animation.play());
    
    // 触发右侧内容切换（保留原有逻辑）
    const firstLink = this.content.querySelector('.HeaderMenu-MenuList-left a');
    if (firstLink) firstLink.dispatchEvent(new Event('mouseenter'));
  }

  close() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
    this.animations.forEach(animation => animation.cancel());
  }
}

// 注册自定义元素（替换原有的 details-disclosure）
customElements.define('details-disclosure', HoverDetailsDisclosure);

// 保留原有的 HeaderMenu 逻辑（继承自新的 HoverDetailsDisclosure）
class HeaderMenu extends HoverDetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.details.open;
    
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);